import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './GallerySection.css';

function GallerySection() {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      id: 1,
      src: '/assets/imgs/destination/serengeti1.jpg',
      alt: 'Serengeti National Park',
      title: 'Serengeti Wildlife'
    },
    {
      id: 2,
      src: '/assets/imgs/destination/ngorongoro.webp',
      alt: 'Ngorongoro Crater',
      title: 'Ngorongoro Crater'
    },
    {
      id: 3,
      src: '/assets/imgs/destination/tarangire.jpg',
      alt: 'Tarangire National Park',
      title: 'Tarangire Elephants'
    },
    {
      id: 4,
      src: '/assets/imgs/destination/zanzibar.jpeg',
      alt: 'Zanzibar Beach',
      title: 'Zanzibar Paradise'
    },
    {
      id: 5,
      src: '/assets/imgs/destination/lake-manyara.jpg',
      alt: 'Lake Manyara',
      title: 'Lake Manyara'
    },
    {
      id: 6,
      src: '/assets/imgs/destination/arusha-national-park.jpg',
      alt: 'Arusha National Park',
      title: 'Arusha National Park'
    },
    {
      id: 7,
      src: '/assets/imgs/destination/ngorongoro1.jpg',
      alt: 'Ngorongoro Landscape',
      title: 'Ngorongoro Views'
    },
    {
      id: 8,
      src: '/assets/imgs/destination/tarangire1.jpg',
      alt: 'Tarangire Landscape',
      title: 'Tarangire Scenery'
    },
    {
      id: 9,
      src: '/assets/imgs/destination/manyara.jpg',
      alt: 'Manyara Wildlife',
      title: 'Manyara Wildlife'
    }
  ];

  const openLightbox = (image) => {
    setSelectedImage(image);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  return (
    <section className="gallery-section">
      <div className="gallery-container">
        <div className="gallery-header">
          <h2 className="gallery-title">Recent Gallery</h2>
          <p className="gallery-subtitle">
            Explore the breathtaking beauty of Tanzania through our recent adventures
          </p>
        </div>

        <div className="gallery-grid">
          {galleryImages.map((image) => (
            <div 
              key={image.id} 
              className="gallery-item"
              onClick={() => openLightbox(image)}
            >
              <div className="gallery-image-wrapper">
                <img 
                  src={image.src} 
                  alt={image.alt}
                  className="gallery-image"
                  loading="lazy"
                />
                <div className="gallery-overlay">
                  <h3 className="gallery-image-title">{image.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="gallery-cta">
          <Link to="/gallery" className="gallery-view-all-btn">
            View All Photos
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div className="gallery-lightbox" onClick={closeLightbox}>
          <div className="gallery-lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button 
              className="gallery-lightbox-close"
              onClick={closeLightbox}
              aria-label="Close lightbox"
            >
              &times;
            </button>
            <img 
              src={selectedImage.src} 
              alt={selectedImage.alt}
              className="gallery-lightbox-image"
            />
            <p className="gallery-lightbox-title">{selectedImage.title}</p>
          </div>
        </div>
      )}
    </section>
  );
}

export default GallerySection;

